import { ROUTES } from '#/config/routes';

/**
 * @typedef {'repairRequest' | 'repairItem' | 'repairReport' | 'signReceipt' | 'snProductMapping'} AftersalesOpsPageKey
 */

export const AFTERSALES_OPS_PAGE_CONFIG = {
  repairRequest: {
    title: '報修單列表',
    listRoute: ROUTES.repairRequest,
    createRoute: ROUTES.repairRequestCreate,
  },
  repairItem: {
    title: '維修品項',
    listRoute: ROUTES.repairItem,
  },
  repairReport: {
    title: '維修報告',
    listRoute: ROUTES.repairReport,
  },
  signReceipt: {
    title: '簽收單列表',
    listRoute: ROUTES.signReceipt,
    createRoute: ROUTES.signReceiptCreate,
  },
  snProductMapping: {
    title: '物料序號',
    listRoute: ROUTES.snProductMapping,
    createRoute: ROUTES.snProductMappingCreate,
  },
};

/**
 * form 殼：僅返回該模式列表（列表頁不再互跳，改由 Aside 三子項切換）。
 * @param {AftersalesOpsPageKey} currentPage
 */
export function getAftersalesOpsFormNavItems(currentPage) {
  const config = AFTERSALES_OPS_PAGE_CONFIG[currentPage];
  if (!config?.listRoute) {
    return [];
  }

  return [
    {
      label: '返回列表',
      to: config.listRoute,
      variant: 'outline',
    },
  ];
}
